import { getAssetImageUrl } from '@util/common.js';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

ListItem.propTypes = {
  name: PropTypes.string,
  shortDescription: PropTypes.string,
  thumbnail: PropTypes.string,
  link: PropTypes.string,
  isNew: PropTypes.bool,
  isUpdated: PropTypes.bool,
};
export default function ListItem({
  name,
  shortDescription,
  thumbnail,
  link,
  isNew,
  isUpdated,
}) {
  let badgeBlock;

  if (isNew)
    badgeBlock = (
      <span className="ml-2 badge badge-lg badge-secondary">NEW</span>
    );
  else if (isUpdated)
    badgeBlock = (
      <span className="ml-2 badge badge-lg badge-accent">UPDATED</span>
    );

  return (
    <NavLink
      unstable_viewTransition
      to={link}
      className="join-item border-gray-200 light-grey transition-colors hover:bg-base-300 border px-4 py-6"
    >
      <div className="flex-grow flex md:flex-row flex-col-reverse md:items-center">
        <div className="flex-grow">
          <h1 className="text-xl font-bold ">
            {name}
            {badgeBlock}
          </h1>
          <article className="text-lg">{shortDescription}</article>
        </div>

        <div className="h-12 block mb-3 md:mb-0 mr-3">
          <img
            className="h-full"
            src={getAssetImageUrl(thumbnail)}
            alt="Thumbnail"
          />
        </div>
      </div>
    </NavLink>
  );
}
